import { Link } from "react-router-dom";
import type { Game } from "@/types";
import { getTeamById, getTeamPlayers } from "@/utils/nba";
import TeamBadge from "@/components/base/TeamBadge";

interface RosterPanelProps {
  game: Game;
}

export default function RosterPanel({ game }: RosterPanelProps) {
  const home = getTeamById(game.homeTeamId);
  const away = getTeamById(game.awayTeamId);
  if (!home || !away) return null;

  const groups = [
    { team: away, players: getTeamPlayers(away.id) },
    { team: home, players: getTeamPlayers(home.id) },
  ];

  return (
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      {groups.map((group) => (
        <div key={group.team.id} className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
          <div className="mb-4 flex items-center gap-3">
            <TeamBadge team={group.team} size="sm" />
            <Link
              to={`/team/${group.team.id}`}
              className="font-heading text-base font-semibold text-foreground-950 hover:text-primary-700 cursor-pointer"
            >
              {group.team.fullName}
            </Link>
          </div>

          {group.players.length > 0 ? (
            <div className="space-y-1">
              <div className="grid grid-cols-12 gap-2 px-3 pb-2 text-xs text-foreground-400">
                <span className="col-span-5">球员</span>
                <span className="col-span-2 text-center">得分</span>
                <span className="col-span-2 text-center">篮板</span>
                <span className="col-span-3 text-center">助攻</span>
              </div>
              {group.players.map((player) => (
                <Link
                  key={player.id}
                  to={`/player/${player.id}`}
                  className="grid grid-cols-12 items-center gap-2 rounded-md px-3 py-2.5 text-sm transition-colors hover:bg-primary-50 cursor-pointer"
                >
                  <div className="col-span-5 flex items-center gap-2 min-w-0">
                    <span className="w-6 h-6 rounded-full bg-background-100 flex items-center justify-center text-[10px] font-bold text-foreground-600 shrink-0">
                      {player.number}
                    </span>
                    <div className="min-w-0">
                      <p className="truncate text-foreground-900">{player.name}</p>
                      <p className="text-[11px] text-foreground-400">{player.position}</p>
                    </div>
                  </div>
                  <span className="col-span-2 text-center font-medium text-foreground-900">{player.seasonStats.ppg}</span>
                  <span className="col-span-2 text-center text-foreground-700">{player.seasonStats.rpg}</span>
                  <span className="col-span-3 text-center text-foreground-700">{player.seasonStats.apg}</span>
                </Link>
              ))}
            </div>
          ) : (
            <p className="rounded-md border border-dashed border-background-300 py-8 text-center text-sm text-foreground-500">
              全明星阵容由当期票选球员组成，暂不提供完整名单
            </p>
          )}
        </div>
      ))}
    </div>
  );
}